import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "folder-container" }
const _hoisted_2 = {
  key: 0,
  class: "folder-children-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TreeFile = _resolveComponent("TreeFile")!
  const _component_TreeFolder = _resolveComponent("TreeFolder", true)!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "folder-text-div",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setOpen(!_ctx.open)))
    }, [
      _createElementVNode("div", null, _toDisplayString(`${_ctx.open ? '﹀' : '〉'}`), 1),
      _createElementVNode("div", null, _toDisplayString(_ctx.data.name), 1)
    ]),
    (_ctx.open)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.children, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.name
            }, [
              (item.type === 'file')
                ? (_openBlock(), _createBlock(_component_TreeFile, {
                    key: 0,
                    onFileOpened: _ctx.onFileClicked,
                    data: (item as ITreeFile)
                  }, null, 8, ["onFileOpened", "data"]))
                : _createCommentVNode("", true),
              (item.type === 'folder')
                ? (_openBlock(), _createBlock(_component_TreeFolder, {
                    key: 1,
                    data: (item as ITreeFolder),
                    onFileOpened: _ctx.onFileClicked
                  }, null, 8, ["data", "onFileOpened"]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}